import { render } from "./feedback-button.vue?vue&type=template&id=48ca3d66&ts=true"
import script from "./feedback-button.vue?vue&type=script&lang=ts"
export * from "./feedback-button.vue?vue&type=script&lang=ts"

import "./feedback-button.vue?vue&type=style&index=0&id=48ca3d66&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__